import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import { imgUrl } from "../../utils/config";
import { useState, useEffect } from "react";
import {
  getCategoriesDetails,
  getHomeOfferDetails,
  updateFanduPoints,
} from "../../utils/api";
import "./css/tailwind.css";
import { logEvent } from "../../utils/eventTracker";
import style from "../../screens/Questions/css/Questions.module.css";
import banner1 from "../../icons/fire.webp";
function SeeMore() {
  const [categories, setCategories] = useState([]);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getCategoriesDetails();
      if (response.is_success && Array.isArray(response.message)) {
        const activeCategories = response.message.filter(
          (cat) => cat.status === "active",
        );
        setCategories(response.message);
        if (activeCategories.length > 0) {
          const firstCategory = activeCategories[0].category;
          setActiveCategory(firstCategory);
          fetchCategorisedOffers(firstCategory);
        }
      } else {
        console.error("Unexpected response format:", response);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategorisedOffers = async (categoryName) => {
    setLoading(true);
    try {
      const response = await getHomeOfferDetails(categoryName);
      if (response.is_success && Array.isArray(response.message)) {
        const filtered = response.message.filter(
          (offer) =>
            offer.category.toLowerCase() === categoryName.toLowerCase() &&
            offer.status === "active",
        );
        setOffers(filtered);
      }
    } catch (error) {
      console.error("Error fetching category offers:", error);
    } finally {
      setLoading(false);
    }
  };

  const impressionObject = {
    Event_Name: "See_More_Categories_Page",
    Event_Sub_Name: "See_More_Page",
    Event_Type: "Page_Open",
    Event_Sub_Type: "list_view",
    Offer_Type: "Categories",
    user_id: localStorage.getItem("userId"),
    Event_MetaData: {
      ...offers.reduce((specialOffer, offer) => {
        specialOffer[offer.id] = offer.category;
        return specialOffer;
      }, {}),
      offer_type: "Categories",
    },
  };

  const CategoryImpressions = (eventName) => {
    return {
      Event_Name: `See_More_Category_${eventName}`,
      Event_Sub_Name: "See_More_Page",
      Event_Type: "Click",
      Event_Sub_Type: "list_view",
      Offer_Type: "Categories",
      user_id: localStorage.getItem("userId"),
      Event_MetaData: {
        ...offers.reduce((specialOffer, offer) => {
          specialOffer[offer.id] = offer.category;
          return specialOffer;
        }, {}),
        offer_type: "Categories",
      },
    };
  };

  const availImpressions = {
    Event_Name: "See_More_Categories_Avail",
    Event_Sub_Name: "See_More_Page",
    Event_Type: "Click",
    Event_Sub_Type: "avail_coupon",
    Offer_Type: "Categories",
    user_id: localStorage.getItem("userId"),
    Event_MetaData: {
      ...offers.reduce((specialOffer, offer) => {
        specialOffer[offer.id] = offer.category;
        return specialOffer;
      }, {}),
      offer_type: "Categories",
    },
  };

  const rewardAvailPoints = async (offer) => {
    try {
      const fanduUserId = localStorage.getItem("fanduUserId");

      if (!fanduUserId) return;

      const rewardedOffers =
        JSON.parse(localStorage.getItem("rewardedAvailOffers")) || [];

      // reward only once per offer
      if (rewardedOffers.includes(offer.id)) {
        return;
      }

      const response = await updateFanduPoints({
        user_id: fanduUserId,
        score: 1,
        remark:"Special Offer banners"
      });

      const updatedPoints = Number(response?.score) || 0;

      localStorage.setItem("userFanduPoints", updatedPoints);
    } catch (error) {
      console.log("Avail reward error", error);
    }
  };

  useEffect(() => {
    fetchData();
    logEvent(impressionObject);
  }, []);

  if (loading && offers.length === 0) return <p>Loading offers...</p>;

  return (
    <div className="p-4 tw lg:mx-16">
      <Navbar />
      <h2 className="md:text-3xl text-2xl font-bold text-[#0072B1] mt-8 text-center">
        Discover the Best Offers
      </h2>
      <p className="text-md mt-1 text-center">
        Handpicked deals from trusted online stores, just for you.
      </p>

      <div className="mt-8 flex justify-between md:justify-around gap-x-2">
        {categories.map((cat, i) => (
          <div className="flex flex-col gap-y-1 items-center">
            <div
              key={i}
              onClick={() => {
                setActiveCategory(cat.category);
                fetchCategorisedOffers(cat.category);
                logEvent(CategoryImpressions(cat.category));
              }}
              className={`flex items-center p-0.5 justify-center rounded-full text-center text-sm
  ${activeCategory === cat.category && "bg-[#0072B1]"}`}
            >
              <img
                src={`${imgUrl}${cat.image_name}`}
                className="cursor-pointer w-14 h-14 md:h-32 md:w-32 rounded-full"
              />
            </div>
            <p
              className={`text-xs ${
                activeCategory === cat.category
                  ? " text-[#0072B1]"
                  : "text-[#ED1A68]"
              }`}
            >
              {cat.category === "Beauty & Personal Care"
                ? "Beauty Care"
                : cat.category}
            </p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-y-6 gap-x-4 lg:gap-x-16 mt-10">
        {offers.map((offer, i) => (
          <div className="rounded-lg border p-2 shadow-y-md" key={i}>
            <div className="flex gap-x-5">
              <img
                src={`${imgUrl}${offer.image_name}`}
                alt={`${offer.image_name}`}
                className="rounded-lg w-2/5 aspect-auto"
              />
              <div className="flex flex-col">
                <div className="flex justify-center">
                  <img
                    src={`${imgUrl}${offer.logo}`}
                    className="rounded-lg h-16"
                  />
                </div>
                <p className="text-[#ED1A68] text-md">{offer.deal_name}</p>
                <p className="text-gray-500 font-light text-xs w-36 overflow-hidden truncate">
                  {offer.description}
                </p>
                <div
                  className="flex gap-x-2 mt-2"
                  onClick={() => logEvent(availImpressions)}
                >
                  <div className="rounded-md border border-dashed px-2 text-xs py-1">
                    {offer.coupon_code}
                  </div>
                  <Link
                    to={offer.redirection_url}
                    onClick={() => rewardAvailPoints(offer)}
                    className="rounded-md no-underline bg-[#ED1A68] cursor-pointer text-white px-2 text-xs py-1"
                  >
                    Avail Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className={style.hotDealsBottomRight}>
        <Link to="/hot-deals">
          <img src={banner1} alt="Hot Deals" className={style.hotDealsBtn} />
        </Link>
      </div>
    </div>
  );
}

export default SeeMore;
